/* eslint-disable max-len */
import React from 'react';

export const BoltOutline = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            aria-hidden='true'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143zM5.475 12.75H12a.75.75 0 01.724.947l-1.452 5.323 7.252-7.77H12a.75.75 0 01-.724-.947l1.452-5.323-7.252 7.77z'
                fill='currentcolor'
            />
        </svg>
    );
};
